import { Controller } from '@hotwired/stimulus'
import { i18n } from 'config/translations'

export default class extends Controller {
  static targets = [
    'fileStatus',
    'fileNameStatus',
    'fileNameListStatus',
    'inputFieldStatus',
    'deleteButton',
    'defaultFileHead',
    'errorStatus',
    'fileField',
  ]

  initialize() {
    this.counter = 1
  }

  displayFileName(e) {
    const clonedNode = this.fileNameStatusTarget.cloneNode(true)
    const counter = this.counter

    const attachment = i18n.t('views.mypage.form.todo_uploads.attachment')
    const fileSizeErrorMessage = i18n.t('views.mypage.form.todo_uploads.file_size_error')

    this.clearErrorMessage()

    // ファイル名の取得、挿入
    const file = e.target.files[0]
    if (file.size > 2 * 1024 * 1024) {
      this.showErrorMessage(fileSizeErrorMessage)
      return
    }

    clonedNode.classList.remove('hidden')
    clonedNode.querySelector('h2').textContent = `${attachment}${counter}`
    clonedNode.querySelector('p').textContent = file.name
    clonedNode.setAttribute('id', `fileName_${counter}`)
    clonedNode.querySelector('.delete-btn').setAttribute('id', `deleteFile_${counter}`)
    this.fileNameListStatusTarget.appendChild(clonedNode)
    this.counter++

    // ファイルフィールドの挿入
    this.defaultFileHeadTarget.textContent = `${attachment}${counter + 1}`
    this.defaultFileHeadTarget.nextElementSibling.classList.add('hidden')
    this.inputFieldStatusTargets.forEach((element) => {
      element.classList.add('hidden')
    })
    const cloneInputFileFiled = this.inputFieldStatusTarget.cloneNode(true)
    cloneInputFileFiled.querySelector('input[type="file"]').value = ''
    cloneInputFileFiled.setAttribute('id', `file_${counter + 1}`)
    this.inputFieldStatusTarget.parentNode.appendChild(cloneInputFileFiled)
    this.inputFieldStatusTarget.parentNode.lastElementChild.classList.remove('hidden')
  }

  deleteFile(e) {
    const fileNumber = e.currentTarget.id.match(/\d+$/)
    const attachment = i18n.t('views.mypage.form.todo_uploads.attachment')

    document.getElementById(`fileName_${fileNumber}`).remove()
    document.getElementById(`file_${fileNumber}`).remove()
    this.fileNameStatusTargets.forEach((element) => {
      const indexNumber = element.id.match(/\d+$/)
      if (indexNumber > fileNumber) {
        const newIndexNumber = indexNumber - 1
        element.id = `fileName_${newIndexNumber}`
        let fileName = element.querySelector('h2').textContent
        if (fileName) {
          fileName = `${attachment}${newIndexNumber}`
          element.querySelector('h2').textContent = fileName
        }
        element.querySelector('.delete-btn').id = `deleteFile_${newIndexNumber}`
        document.getElementById(`file_${indexNumber}`).id = `file_${newIndexNumber}`
      }
    })
    this.counter--
    this.defaultFileHeadTarget.textContent = `${attachment}${this.counter}`
    document.getElementById(`file_${this.counter + 1}`).id = `file_${this.counter}`
  }

  showErrorMessage(message) {
    // エラーメッセージ用の要素を取得または作成
    let errorMessageEl = document.querySelector('.error-message')
    errorMessageEl = document.createElement('p')
    errorMessageEl.className = 'error-message'
    errorMessageEl.style.color = '#a94442'
    errorMessageEl.style.fontSize = '12px'
    this.errorStatusTarget.parentNode.appendChild(errorMessageEl)
    errorMessageEl.textContent = message
  }

  clearErrorMessage() {
    // エラーメッセージ用の要素を取得して削除
    const errorMessageEl = document.querySelector('.error-message')
    if (errorMessageEl) {
      errorMessageEl.remove()
    }
  }

  toggleFileField(e) {
    const selectedValue = e.target.value
    this.fileFieldTarget.classList.toggle('hidden', selectedValue !== 'true')
  }
}
